


import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
import { createReducer, on  } from '@ngrx/store';
import { get } from 'lodash';

import { ScreenState } from '@core/store';
import { User as UserModel } from '@models/user.model';


import * as fromMaster from './master-create-user-wizard.actions';
import * as fromStore from '@app/core/store';
import * as featureAdapter from '@core/store/feature-adapter';

export interface State extends EntityState<ScreenState<UserModel>> { }
export const adapter: EntityAdapter<ScreenState<UserModel>> = createEntityAdapter<ScreenState<UserModel>>({});

export const initialState: State = adapter.getInitialState();

const _reducer = createReducer(initialState,
    on(fromMaster.destroyAction, (state, payload) =>
      adapter.removeOne(payload, state)
    ),
    on(fromMaster.initStateAction, (state, payload) =>
      adapter.addOne({ ...payload, loading: false}, state)
    ),
    on(fromMaster.nextAction, (state, payload) =>
    adapter.updateOne({ id: payload.id, changes: { loading: true } }, state)
    ),
    on(fromMaster.nextSuccessAction, (state, payload) => {
      const changes = {
        loading: false,
        currentIndex: state['entities'][payload.id].currentIndex + 1
      };
      return adapter.updateOne({ id: payload.id, changes }, state);
    }),
    on(fromMaster.nextFailAction, (state, payload) =>
      adapter.updateOne({ id: payload.id, changes: { loading: false } }, state)
    ),
    on(fromMaster.previousAction, (state, payload) => {
      const changes = {
        loading: false,
        currentIndex: state['entities'][payload.id].currentIndex - 1
      };
      return adapter.updateOne({ id: payload.id, changes }, state);
    }),
    on(fromMaster.confirmAction, (state, payload) =>
    adapter.updateOne({ id: payload.id, changes: { loading: true } }, state)
    ),
    on(fromMaster.confirmSuccessAction, (state, payload) => {
      const changes = {
        loading: false,
      };
      return adapter.updateOne({ id: payload.id, changes }, state);
    }),
    on(fromMaster.confirmFailAction, (state, payload) =>
      adapter.updateOne({ id: payload.id, changes: { loading: false } }, state)
    ),
);

export function reducer(state, action) {
  return _reducer(state, action);
}


